import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';
import FinalFileCard from 'components/form/FileDrop/FinalFileCard';
import FinanceCalculator from 'components/shared/FinanceCalculator';
import { CLASS_NAMES } from './constants';
import { JobItems, WorkType } from './Fields';
import useEnquiryQuoteConfirmDetailsForm from './useEnquiryQuoteConfirmDetailsForm';

const EnquiryQuoteConfirmDetails: React.FunctionComponent = function () {
  const {
    form,
    onSubmit,
    isLoading,
    isSubmitting,
    quote,
    total,
    workType,
    infoWorkTypes,
  } = useEnquiryQuoteConfirmDetailsForm();
  return (
    <>
      <Form id="enquiry-quote-confirm-details" form={form} onSubmit={onSubmit}>
        <FormTheme variant="streamline">
          <div className="flex flex-col mt-2">
            <h1 className={CLASS_NAMES.header}>Confirm quote details</h1>
            <h3 className={CLASS_NAMES.subheader}>
              Ideal4Finance have extracted the below information from the quote
              you uploaded. Please confirm the details are consistent with those
              on the quote you received - inaccurate information may lead to
              issues with your finance application.
            </h3>
            <h3 className={CLASS_NAMES.subheader}>
              You can use our handy finance calculator at the bottom of the page
              to calculate repayments on our finance options
            </h3>
            {!isLoading && (
              <>
                {quote && <FinalFileCard file={quote} />}
                <div className="mb-5" />
                <WorkType />
                <JobItems />
              </>
            )}
            <Button.Text
              id="enquiry-quote-confirm-details-submit"
              submit
              label="Confirm Details"
              variant="gradient"
              className="mt-10"
              disabled={isSubmitting}
            />

            <Loader isLoading={isSubmitting} />
          </div>
        </FormTheme>
      </Form>
      <div className="my-10 w-full border-b border-neutral-300" />
      <FinanceCalculator
        workType={workType}
        infoWorkTypes={infoWorkTypes}
        isLoading={isLoading}
        initialValue={total}
      />
    </>
  );
};

export default EnquiryQuoteConfirmDetails;
